import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.modal = this.element.closest(".modal")
    if (!this.modal) return

    this.boundClear = () => this.clear()
    $(this.modal).on("show.bs.modal hidden.bs.modal", this.boundClear)
  }

  disconnect() {
    if (this.modal) $(this.modal).off("show.bs.modal hidden.bs.modal", this.boundClear)
  }

  clear() {
    this.element.checked = false
  }
}
